var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearchAutomobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 887,
    height: 492,
    viewBox: "0 0 887 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.395 154.01C260.431 154.01 283.158 131.282 283.158 103.247C283.158 75.2116 260.431 52.4844 232.395 52.4844C204.36 52.4844 181.633 75.2116 181.633 103.247C181.633 131.282 204.36 154.01 232.395 154.01Z",
    fill: "#FF6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.582 259.678H142.556C142.244 259.682 141.932 259.658 141.625 259.605L259.403 55.596C260.122 54.3254 261.165 53.2685 262.426 52.5331C263.687 51.7977 265.121 51.4102 266.58 51.4102C268.04 51.4102 269.474 51.7977 270.735 52.5331C271.996 53.2685 273.039 54.3254 273.758 55.596L352.802 192.502L356.589 199.052L391.582 259.678Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M391.582 259.678H306.558L348.296 199.052L351.3 194.685L352.802 192.502L356.589 199.052L391.582 259.678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.238 259.678H314.851L356.588 199.052L359.592 194.685L413.98 115.678C417.546 110.5 426.124 110.177 430.316 114.701C430.598 115.01 430.859 115.336 431.099 115.678L530.238 259.678Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.464 226.116C601.912 226.116 608.76 219.268 608.76 210.82C608.76 202.372 601.912 195.523 593.464 195.523C585.015 195.523 578.167 202.372 578.167 210.82C578.167 219.268 585.015 226.116 593.464 226.116Z",
    fill: "#5D3587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.938 256.894H591.805L593.233 208.516L594.938 256.894Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.509 217.685L596.873 213.031L593.463 218.837L593.095 218.192L593.509 217.685Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.141 222.383L589.777 217.73L593.187 223.535L593.555 222.89L593.141 222.383Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.78 226.116C742.228 226.116 749.076 219.268 749.076 210.82C749.076 202.372 742.228 195.523 733.78 195.523C725.332 195.523 718.483 202.372 718.483 210.82C718.483 219.268 725.332 226.116 733.78 226.116Z",
    fill: "#5D3587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.254 256.894H732.121L733.55 208.516L735.254 256.894Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.826 217.685L737.19 213.031L733.78 218.837L733.411 218.192L733.826 217.685Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.458 222.383L730.094 217.73L733.504 223.535L733.872 222.89L733.458 222.383Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.774 211.437C650.251 211.437 660.366 201.323 660.366 188.846C660.366 176.369 650.251 166.254 637.774 166.254C625.297 166.254 615.183 176.369 615.183 188.846C615.183 201.323 625.297 211.437 637.774 211.437Z",
    fill: "#5D3587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.952 256.893H635.325L637.434 185.443L639.952 256.893Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.844 198.985L642.81 192.113L637.776 200.687L637.23 199.734L637.844 198.985Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.298 205.927L632.331 199.055L637.366 207.628L637.911 206.676L637.298 205.927Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.868 211.437C705.345 211.437 715.46 201.323 715.46 188.846C715.46 176.369 705.345 166.254 692.868 166.254C680.391 166.254 670.276 176.369 670.276 188.846C670.276 201.323 680.391 211.437 692.868 211.437Z",
    fill: "#5D3587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.046 256.893H690.419L692.528 185.443L695.046 256.893Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.936 198.985L697.904 192.113L692.868 200.687L692.324 199.734L692.936 198.985Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.392 205.927L687.424 199.055L692.46 207.628L693.004 206.676L692.392 205.927Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.969 211.437C562.446 211.437 572.56 201.323 572.56 188.846C572.56 176.369 562.446 166.254 549.969 166.254C537.492 166.254 527.377 176.369 527.377 188.846C527.377 201.323 537.492 211.437 549.969 211.437Z",
    fill: "#5D3587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.146 256.893H547.519L549.629 185.443L552.146 256.893Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.037 198.985L555.004 192.113L549.969 200.687L549.425 199.734L550.037 198.985Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.493 205.927L544.525 199.055L549.561 207.628L550.105 206.676L549.493 205.927Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.25 491.632H79.984C70.6951 491.632 61.4971 489.802 52.9153 486.248C44.3334 482.693 36.5358 477.483 29.9675 470.914C23.3993 464.346 18.189 456.549 14.6343 447.967C11.0796 439.385 9.25 430.187 9.25 420.898C9.25 411.609 11.0796 402.411 14.6343 393.829C18.189 385.247 23.3993 377.45 29.9675 370.881C36.5358 364.313 44.3334 359.103 52.9153 355.548C61.4971 351.994 70.6951 350.164 79.984 350.164H815.617C822.833 350.164 829.753 347.298 834.855 342.196C839.957 337.094 842.823 330.174 842.823 322.959C842.823 315.743 839.957 308.823 834.855 303.721C829.753 298.619 822.833 295.753 815.617 295.753H55.4992V252.225H815.617C834.377 252.225 852.369 259.677 865.634 272.942C878.899 286.207 886.351 304.199 886.351 322.959C886.351 341.718 878.899 359.71 865.634 372.975C852.369 386.24 834.377 393.693 815.617 393.693H79.984C72.7687 393.693 65.8489 396.559 60.7469 401.661C55.6449 406.763 52.7786 413.683 52.7786 420.898C52.7786 428.113 55.6449 435.033 60.7469 440.135C65.8489 445.237 72.7687 448.103 79.984 448.103H817.25V491.632Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.439 272.9H82.7041V275.077H116.439V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.201 272.9H178.467V275.077H212.201V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.965 272.9H274.23V275.077H307.965V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.728 272.9H369.993V275.077H403.728V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.491 272.9H465.756V275.077H499.491V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.254 272.9H561.52V275.077H595.254V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.017 272.9H657.282V275.077H691.017V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.78 272.9H753.045V275.077H786.78V272.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.439 370.84H82.7041V373.016H116.439V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.201 370.84H178.467V373.016H212.201V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.965 370.84H274.23V373.016H307.965V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.728 370.84H369.993V373.016H403.728V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.491 370.84H465.756V373.016H499.491V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.254 370.84H561.52V373.016H595.254V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.017 370.84H657.282V373.016H691.017V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.78 370.84H753.045V373.016H786.78V370.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.439 468.779H82.7041V470.956H116.439V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.201 468.779H178.467V470.956H212.201V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.965 468.779H274.23V470.956H307.965V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.728 468.779H369.993V470.956H403.728V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.491 468.779H465.756V470.956H499.491V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.254 468.779H561.52V470.956H595.254V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.017 468.779H657.282V470.956H691.017V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.78 468.779H753.045V470.956H786.78V468.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.868 86.375C595.412 86.3717 598.898 87.2726 601.997 88.9924H581.765C584.854 87.2731 588.332 86.3721 591.868 86.375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.606 83.7559C558.526 83.749 564.303 85.5779 569.14 88.9907H536.095C540.926 85.5819 546.694 83.7531 552.606 83.7559Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.212 50.6226C330.93 37.9268 336.134 25.8987 344.895 16.6827C353.657 7.46673 365.406 1.66195 378.05 0.30333C390.693 -1.05529 403.408 2.12054 413.927 9.26462C424.447 16.4087 432.087 27.0566 435.486 39.31C436.136 39.2867 436.786 39.2606 437.442 39.2606C449.034 39.2627 460.314 43.0181 469.594 49.965C478.874 56.9119 485.656 66.6768 488.924 77.7989C496.605 74.4237 505.189 73.6915 513.331 75.7168C521.474 77.7421 528.714 82.4106 533.919 88.9911H366.547C361.664 89.005 356.829 88.0333 352.331 86.1345C347.832 84.2356 343.763 81.4485 340.367 77.9401C336.971 74.4316 334.318 70.274 332.566 65.7161C330.815 61.1582 330.001 56.2937 330.174 51.414C330.185 51.1506 330.197 50.8868 330.212 50.6226Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.08 125.551C600.536 125.547 597.05 126.448 593.951 128.168H614.184C611.094 126.449 607.616 125.548 604.08 125.551Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.342 122.932C637.422 122.925 631.645 124.754 626.808 128.166H659.853C655.022 124.758 649.254 122.929 643.342 122.932Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.736 89.7984C865.018 77.1026 859.815 65.0745 851.053 55.8585C842.292 46.6425 830.542 40.8377 817.899 39.4791C805.255 38.1205 792.541 41.2963 782.021 48.4404C771.502 55.5845 763.861 66.2324 760.462 78.4858C759.812 78.4624 759.163 78.4363 758.507 78.4363C746.915 78.4385 735.635 82.1939 726.354 89.1408C717.074 96.0877 710.293 105.853 707.025 116.975C699.343 113.6 690.759 112.867 682.617 114.893C674.475 116.918 667.234 121.586 662.029 128.167H829.401C834.284 128.181 839.12 127.209 843.618 125.31C848.116 123.411 852.185 120.624 855.581 117.116C858.977 113.607 861.631 109.45 863.382 104.892C865.134 100.334 865.947 95.4695 865.774 90.5897C865.764 90.3263 865.751 90.0626 865.736 89.7984Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.152 461.212L773.604 461.223L773.606 458.135L754.154 458.125L754.152 461.212Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.507 458.821L617.52 459.749L770.054 459.831L771.425 456.635C773.818 451.153 774.639 445.115 773.797 439.193C773.14 434.78 771.494 430.394 767.755 428.489L760.986 383.405L676.597 383.254L643.947 409.588C643.947 409.588 628.546 409.311 620.179 419.728C617.16 423.601 615.378 428.293 615.064 433.194L614.734 438.612L613.507 458.821Z",
    fill: "#5D3587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.009 476.903C657.411 476.903 665.844 468.47 665.844 458.068C665.844 447.665 657.411 439.232 647.009 439.232C636.607 439.232 628.174 447.665 628.174 458.068C628.174 468.47 636.607 476.903 647.009 476.903Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.009 467.981C652.484 467.981 656.922 463.542 656.922 458.068C656.922 452.593 652.484 448.154 647.009 448.154C641.534 448.154 637.096 452.593 637.096 458.068C637.096 463.542 641.534 467.981 647.009 467.981Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.949 476.951C750.352 476.951 758.784 468.519 758.784 458.116C758.784 447.714 750.352 439.281 739.949 439.281C729.547 439.281 721.114 447.714 721.114 458.116C721.114 468.519 729.547 476.951 739.949 476.951Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.949 468.03C745.424 468.03 749.863 463.591 749.863 458.116C749.863 452.641 745.424 448.203 739.949 448.203C734.474 448.203 730.036 452.641 730.036 458.116C730.036 463.591 734.474 468.03 739.949 468.03Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.92 406.512L702.483 406.531H708.045L717.435 406.538V405.853L717.442 397.595L717.449 388.323H711.201L705.639 388.317L695.787 388.31H690.225L678.851 388.303L656.92 406.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.849 406.543L748.929 406.556L748.935 401.831V393.573L748.942 388.341H745.416L739.854 388.334L724.856 388.328L724.849 406.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.339 425.991L717.427 425.992L717.43 420.125L714.342 420.124L714.339 425.991Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.264 414.851L669.266 411.764L663.399 411.761L663.397 414.848L669.264 414.851Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.104 413.121L666.764 413.121C665.916 413.12 665.077 412.953 664.295 412.628C663.512 412.304 662.801 411.828 662.202 411.228C661.603 410.629 661.128 409.917 660.804 409.134C660.48 408.351 660.313 407.512 660.314 406.664C660.314 405.817 660.482 404.978 660.807 404.195C661.131 403.412 661.607 402.701 662.207 402.102C662.806 401.503 663.518 401.028 664.301 400.704C665.084 400.38 665.923 400.214 666.771 400.214L667.11 400.214L667.104 413.121Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.734 438.613C617.069 438.867 619.419 438.289 621.37 436.98C623.32 435.672 624.746 433.717 625.397 431.46C626.048 429.203 625.881 426.789 624.927 424.643C623.972 422.497 622.291 420.757 620.179 419.729C617.161 423.602 615.378 428.294 615.065 433.194L614.734 438.613Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.639 388.316L717.435 405.852L717.442 397.594L711.201 388.322L705.639 388.316Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.854 388.336L748.935 401.833V393.575L745.416 388.343L739.854 388.336Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.225 388.309L702.483 406.53H708.045L695.787 388.309H690.225Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0579 310.987C77.7041 310.987 100.116 288.575 100.116 260.929C100.116 233.283 77.7041 210.871 50.0579 210.871C22.4117 210.871 0 233.283 0 260.929C0 288.575 22.4117 310.987 50.0579 310.987Z",
    fill: "#29183B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2667 275.999L25.2159 250.949C24.401 250.132 23.9437 249.025 23.9443 247.872C23.945 246.718 24.4035 245.612 25.2193 244.796C26.0351 243.98 27.1414 243.521 28.2951 243.521C29.4488 243.52 30.5555 243.978 31.3722 244.792L49.8501 263.27L108.814 196.031C109.576 195.165 110.65 194.637 111.801 194.562C112.952 194.487 114.085 194.872 114.953 195.633C115.82 196.393 116.35 197.467 116.426 198.618C116.502 199.769 116.119 200.903 115.359 201.771L50.2667 275.999Z",
    fill: "#5D3587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_1607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 886.351,
    height: 491.631,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchAutomobile);
export default __webpack_public_path__ + "static/media/ResearchAutomobile.f892fe07a39f86e072eab753324e83f0.svg";
export { ForwardRef as ReactComponent };